export const SearchFilterResults = {
  bindings: {
    filters: '<',
    query: '<',
    onUpdateFilter: '&',
    onUpdateParam: '&',
    onClearAll: '&',
  },

  template: `
    <div class="search-filter-results pt-3"
      ng-show="$ctrl.filters.length || $ctrl.query.length">
      <search-filter-badge
        name="'Clear All'"
        type="clear"
        ng-click="$ctrl.onClearAll()">
      </search-filter-badge>
      <search-filter-badge
        ng-show="$ctrl.query.length"
        name="$ctrl.query"
        ng-click="$ctrl.onUpdateParam({ key: 'q', value: undefined })">
      </search-filter-badge>
      <search-filter-badge
        name="item.name"
        ng-click="$ctrl.onClickUpdate(item)"
        ng-repeat="item in $ctrl.filters track by $index">
      </search-filter-badge>
    </div>`,

  controller() {
    'ngInject';

    return {
      onClickUpdate(item) {
        const key = item.type === 'Serves' ? 'serves' : 'filters';
        this.onUpdateFilter({ item: item, type: item.type, key });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Search/SearchFilterResults.js